import React from 'react';
import { Link } from 'react-router-dom';
import { Instagram } from 'lucide-react';
import './Footer.css';

const Footer = () => {
  const instagram_link = 'https://www.instagram.com/hera.beautystation/';

  return (
    <footer className="footer">
      <div className="footer-content">
        <div className="footer-brand">
          <h3 className="footer-brand-name">Hera Beauty Station</h3>
          <p className="footer-tagline">Beauty, designed for you.</p>
        </div>

        <div className="footer-links">
          <div className="footer-section">
            <h4 className="footer-heading">Servicios</h4>
            <Link to="/cejas" className="footer-link">Diseño de cejas</Link>
            <Link to="/brow-lamination-cdmx" className="footer-link">Brow Lamination</Link>
            <Link to="/korean-lash-lift-cdmx" className="footer-link">Korean Lash Lift</Link>
            <Link to="/nails" className="footer-link">Nail art y uñas</Link>
            <Link to="/wedding" className="footer-link">Hera Weddings</Link>
            <Link to="/servicios" className="footer-link">Todos los servicios</Link>
          </div>

          <div className="footer-section">
            <h4 className="footer-heading">Sucursales</h4>
            <Link to="/sucursales/del-valle" className="footer-link">Del Valle</Link>
            <Link to="/sucursales/condesa" className="footer-link">Condesa</Link>
            <Link to="/sucursales/polanco" className="footer-link">Polanco</Link>
            <Link to="/contacto" className="footer-link">Contacto</Link>
          </div>

          <div className="footer-section">
            <h4 className="footer-heading">Reserva</h4>
            <a href="https://www.fresha.com/es/a/hera-beauty-station-ciudad-de-mexico-xola-630-del-valle-h8q4rchp/all-offer?menu=true" target="_blank" rel="noopener noreferrer" className="footer-link">
              Agenda en Del Valle
            </a>
            <a href="https://www.fresha.com/book-now/hera-beauty-station-pfvu4nej/all-offer?share=true&pId=2842164" target="_blank" rel="noopener noreferrer" className="footer-link">
              Agenda en Condesa
            </a>
            <a href="https://www.fresha.com/es/a/hera-beauty-station-polanco-ciudad-de-mexico-polanco-iv-secc-calle-arquimedes-130-wg70tapr/booking?allOffer=true&menu=true&pId=828922" target="_blank" rel="noopener noreferrer" className="footer-link">
              Agenda en Polanco
            </a>
          </div>

          <div className="footer-section">
            <h4 className="footer-heading">Síguenos</h4>
            <a href={instagram_link} target="_blank" rel="noopener noreferrer" className="footer-social-link">
              <Instagram size={20} />
              <span>Instagram</span>
            </a>
          </div>
        </div>
      </div>

      <div className="footer-bottom">
        <p className="footer-copyright">
          © {new Date().getFullYear()} Hera Beauty Station. Todos los derechos reservados.
        </p>
      </div>
    </footer>
  );
};

export default Footer;